import actions from './actions';

const initState = {
  isLoading: false,
  errorMessage: false,
  userList: [],
  professionList: [],
  exerciseList: []
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOAD_USER_LIST:
      return {
        ...state,
        userList: action.data
      };
    case actions.LOAD_USER_LIST_SUCCESS:
      return {
        ...state,
        userList: action.payload.data,
        pagination: action.payload.pagination,
        errorMessage: false
      };
    case actions.LOAD_EXERCISE_LIST:
      return {
        ...state,
        exerciseList: action.data
      };
    case actions.LOAD_EXERCISE_LIST_SUCCESS:
      return {
        ...state,
        exerciseList: action.payload.data,
        pagination: action.payload.pagination,
        errorMessage: false
      };
    case actions.LOAD_PROFESSION_LIST:
      return {
        ...state,
        professionList: action.data
      };
    case actions.LOAD_PROFESSION_LIST_SUCCESS:
      return {
        ...state,
        professionList: action.payload.data,
        errorMessage: false
      };
    case actions.TOGGLE_LOADING:
      return {
        ...state,
        isLoading: action.payload.value
      };
    default:
      return state;
  }
}
